export default {
  name: "tags-check",
  props:{
    'tagIds':{
      type:Array,
      default(){
        return [];
      }
    },
    'type':{
      type:Number || String,
      default:null,
    },
    'noSelectedPadding':{ 
      type: Boolean,
      default: false,
    },
    'isStranger':{
      type: Boolean,
      default: false,
    },
    'cardBatch':{
      type: Boolean,
      default: false,
    },
    'onlyWatchList':{
      type: Boolean,
      default: false,
    },
     'tagError':{
      type: Boolean,
      default: false,
    },
  },
  data(){
    return{
      tagList:[],/*tag列表*/
      tagName:'',
      searchTimer:'',
      checkedList:[],
      BatchTimer:'',
      cancelToken:null,
      isLoading:false,
    }
  },
  mounted(){
    this.getTagList(true);
  },
  watch:{
    tagIds(){
      if(this.cardBatch){
       clearTimeout(this.BatchTimer);
       this.BatchTimer = setTimeout(() => {
        this.getTagList(true);
       }, 400);
      }
    }
  },
  methods:{
    // 打开tag添加面板
    openTagPanel:function (e) {
      $(e.target).parents('#tag-check').find('.utm-tag-panel').slideDown(300);
    },
    // 查询tag列表
    getTagList:function (isLoad) {
      let _this = this;
      if (_this.cancelToken) {
        _this.cancelToken();
      }
      clearTimeout(_this.searchTimer);
      let searchParams = {
        name: this.isStranger ? 'Watch List': _this.tagName,
        enabledPaging:false,
      };
      if(typeof _this.type !== "undefined"){
        searchParams.types = [_this.type];
      }
   
      let cancelToken = new this.$ajax.CancelToken(function executor(c) {
        _this.cancelToken = c;
      })
      _this.searchTimer = setTimeout(function () {
        _this.isLoading = true;
        _this.tagList = [];
        _this.shareApi.getTagOptions(searchParams,true, cancelToken).done(result =>{
          _this.isLoading = false;
          _this.tagList = _this.sortWatchListTag(result)
          console.log(999,_this.tagList);
          if(isLoad){
            let timer = setTimeout(function () {
              clearTimeout(timer);
              let allTagIds = [];
              if(_this.onlyWatchList){
                _this.tagList=_this.tagList.slice(0, 1)
                _this.checkedList = _this.tagList.filter((tag) =>{
                  allTagIds.push(tag.id);
                  return _this.tagIds.indexOf(tag.id) > -1;
                });
              }else{
                _this.checkedList = _this.tagList.filter((tag) =>{
                  allTagIds.push(tag.id);
                  return _this.tagIds.indexOf(tag.id) > -1;
                });
              }
              _this.$forceUpdate();
              _this.sortCheckedWatchListTag();
              /* 删除选中但已被删除的tag的id,编辑事件中使用 */
              for(let i=0; i<_this.tagIds.length; i++){
                if( allTagIds.indexOf( _this.tagIds[i] ) === -1 ){
                  _this.tagIds.splice(i, 1);
                  --i;
                }
              }
              _this.$emit('getCheckTag',_this.checkedList);
            },500);
          }
        }).fail(() => {
          _this.isLoading = false;
        })
      },300);
    },
    // 选泽
    checkTag:function (tag) {
      let _this = this;
      let index1 = _this.tagIds.findIndex(id => tag.id === id);
      let index2 = _this.checkedList.findIndex(item => tag.id === item.id);
      if(index1 === -1){
        _this.tagIds.push(tag.id);
        _this.checkedList.push(tag);
        _this.sortCheckedWatchListTag();
      }else{
        _this.tagIds.splice(index1,1);
        _this.checkedList.splice(index2,1);
      }
      this.$emit('getCheckTag',_this.checkedList);
    },
    // 删除tag
    deleteTag:function (tag) {
      let _this = this;
      let index1 = _this.tagIds.findIndex(id => tag.id === id);
      let index2 = _this.checkedList.findIndex(item => tag.id === item.id);
      _this.tagIds.splice(index1,1);
      _this.checkedList.splice(index2,1);
      this.$emit('getCheckTag',_this.checkedList);
    },
    // 有watch list tag的可选项排序
    sortWatchListTag: function(arr){
      arr.forEach((item, curIndex)=>{
        if( item.name === 'Watch List' && curIndex !== 0 ){
          let temp = arr[curIndex];
          arr[curIndex] = arr[0];
          arr[0] = temp;
        }
      })
      return arr;
    },
    // "Watch List"tag排序到首位
    sortCheckedWatchListTag:function(){
      let tags = this.checkedList;
      for( let k=0; k<tags.length; k++ ){
        if( tags[k].name === "Watch List" && k !== 0){
          let temp = tags[k];
          tags[k] = tags[0];
          tags[0] = temp;
        }
      }
      this.checkedList = tags;
    },
    getCheckedTags: function() {
      return this.checkedList;
    },
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/tagsCheck.js